module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-EFVRXREJ1T"],"gtagConfig":{"anonymize_ip":true},"pluginConfig":{"head":true,"respectDNT":true}},
    },{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"BRUGG Safety App Website","short_name":"Safety App","start_url":"/","background_color":"#0899D7","theme_color":"#0899D7","display":"minimal-ui","icon":"src/images/safety-app-icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"82669f88a042da515ebc3fd08c64d835"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
